var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"page-menu",attrs:{"default-active":_vm.menuIndex,"router":true,"mode":"horizontal"}},_vm._l((_vm.menu),function(c,i){return _c('el-menu-item',{key:i,attrs:{"index":c.path}},[_vm._v(_vm._s(c.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }